import { Component, OnInit } from '@angular/core';
import { PlanningSettings, SettingsResource } from '@apaq/orgkit-js';
import { container } from 'tsyringe';

@Component({
  selector: 'app-planning-view',
  templateUrl: './planning-view.component.html',
  styleUrls: ['./planning-view.component.scss']
})
export class PlanningViewComponent implements OnInit {

  settings?: PlanningSettings;
  initialized = false;

  constructor(private settingsResource: SettingsResource) {}

  ngOnInit() {
    this.load();
  }

  async load() {
    this.settings = await this.settingsResource.findById('planning');
    setTimeout(() => this.initialized = true, 10);
  }

  get autoPlanEnabled() {
    return !this.settings?.autoPlanDisabled;
  }
  
  set autoPlanEnabled(value: boolean) {
    if(this.settings) {
      this.settings.autoPlanDisabled = !value;
    }
  }

  get dynamicallyPlanCurrentDay() {
    return (this.settings as any).dynamicallyPlanCurrentDay;
  }
  
  set dynamicallyPlanCurrentDay(value: boolean) {
    (this.settings as any).dynamicallyPlanCurrentDay = value;
  }

  async submit() {
    if(this.initialized) {
      this.settings = await this.settingsResource.saveAs(this.settings!, 'planning') as PlanningSettings
    }
  }
}
